import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import {mapContactDetails} from "../../../redux/mappers/MasterMapper/MasterMapper";

export const organizationContactApi = createApi({
  reducerPath: "organizationContactApi",
  baseQuery,
  tagTypes: ["ContactAddress"],
  endpoints: (builder) => ({
        
    getContactAddressByMasterId: builder.query({
      query: ({ id }) => {
        return `/customers/contact/${id}`;
      },
    
      transformResponse: (response) => {
    
        const data = response?.data?.map((item) => ({
          ...item,
          id: item.customerContactId,
        }));
    
        return data;
      },
    
      providesTags: ["ContactAddress"],
    }),
    
    getContactAddId: builder.query({
      query: ({ id }) => {
        console.log("📢 Contact Address API Called with ID:", id);
        return `/customers/contact/${id}`;
      },
    
      transformResponse: (response) => {
        console.log("📦 Raw Contact API Response:", response);
    
        const nestedData = response?.data;
        console.log("📦 Extracted 'data' Level:", nestedData);
    
        const mapped = nestedData.map(mapContactDetails);
        console.log("✨ Final Mapped Contact Data:", mapped);
    
        return mapped;
      },
    
      providesTags: ["Contact"],
    }),
    

    // 🔄 UPDATE entity
    updateContactAddress: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/customers/contact/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { Contact: data }, 

      }),
      invalidatesTags: ["ContactAddress"],
    }),

    // 🔄 DELETE entity
    deleteContactAddress: builder.mutation({
      query: ({ id,subId }) => ({
        url: `customers/contact/${id}/${subId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ContactAddress"],
    }),

    // 🔄 CREATE entity
    createContactAddress: builder.mutation({
      query: ({ id, ...data }) => {   
        const requestBody = { Contact: data };    
        return {
          url: `/customers/contact/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: requestBody,
        };
      },
      invalidatesTags: ["ContactAddress"],
    }),
    
  }),
});

export const {
  useGetContactAddIdQuery,
  useLazyGetContactAddressByMasterIdQuery,
  useUpdateContactAddressMutation,
  useDeleteContactAddressMutation,
  useCreateContactAddressMutation,
} = organizationContactApi;
